import FlowConfigBase from '#client/config/FlowConfigBase';
import * as ROUTES from '#client/constants/routes';

import PAGES, { PAGE_KEYS } from '../flowPageConfig';

export default FlowConfigBase.createEntry({
  id: 'llc-nerdwallet',
  pageKeys: [
    PAGE_KEYS.BUSINESS_INFO,
    PAGE_KEYS.CONTACT_INFO,
    PAGE_KEYS.INDUSTRY,
    PAGE_KEYS.REGISTERED_AGENT,
    PAGE_KEYS.PACKAGE_SELECTION,
    PAGE_KEYS.WFC,
    PAGE_KEYS.EIN,
    PAGE_KEYS.OPERATING_AGREEMENT,
    PAGE_KEYS.MONEY_PRO,
    PAGE_KEYS.RUSH_FILING,
    PAGE_KEYS.CHECKOUT
  ],
  pageConfigs: {
    [PAGES.BUSINESS_INFO.pageComponent]: {
      pageComponentProps: {
        formationCountyStates: new Set(['NY'])
      }
    },
    [PAGES.REGISTERED_AGENT.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          pageHeader: {
            messageKey: 'registeredAgentDiscount',
            messageValues: {
              discountPercent: '50'
            }
          },
          productOfferView: { id: 'registeredAgentDiscount' },
          secondChanceDialog: { messageKey: 'registeredAgentDiscount' }
        },
        couponCode: 'registered_agent_service_deferred_100'
      }
    },
    [PAGES.WFC.pageComponent]: {
      pageComponentProps: {
        couponCode: '199_off_first_year'
      }
    }
  },
  entityType: 'llc',
  isPrimary: true,
  postOrderAutoLogin: true,
  postOrderRedirect: ROUTES.SHOP_LLC_ADDONS,
  priceListUuids: {
    development: '3c9da872-c96d-4e28-be04-4dd8cf8e1a2e',
    production: '19a705a4-3241-4f65-aef1-74a95f6f49b8'
  }
});
